import type {
  SalesAction,
  SalesActionTarget,
} from '@shared/types/sales-action';

/** 保存アンカー (行の target) の同一判定。 */
export function sameTarget(
  a: SalesActionTarget,
  b: SalesActionTarget,
): boolean {
  return a.kind === b.kind && a.id === b.id;
}

/**
 * `anchor` と同じ保存アンカーの open 行が持つソリューション id 集合。
 * 商談化・ソリューション追加の重複ブロックは「行ごとの保存アンカー基準」で判定する
 * (86eya0dva PR3)。read 統一後の一覧には firm アンカー行と弁護士アンカー行が混在し、
 * 同一商品の混在は正当な並存 (open 一意性はアンカー単位) なので、表示行全体からの
 * 商品集約で判定すると偽陽性ブロックになる。
 */
export function openSolutionIdsForAnchor(
  items: SalesAction[],
  anchor: SalesActionTarget,
): string[] {
  return items
    .filter((a) => a.action_status === 'open' && sameTarget(a.target, anchor))
    .map((a) => a.product_id)
    .filter((id): id is string => id !== null);
}
